import { render, staticRenderFns } from "./RegisterGraduationProject.vue?vue&type=template&id=60abd584"
import script from "./RegisterGraduationProject.vue?vue&type=script&lang=js"
export * from "./RegisterGraduationProject.vue?vue&type=script&lang=js"
import style0 from "./RegisterGraduationProject.vue?vue&type=style&index=0&id=60abd584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports